import * as React from 'react';
import { AppMicWidget } from './AppMicWidget';

/** 
 * An enum to define the different states in which the AppMicWidget can be.
 */
export enum AppMicWidgetRecorderState {
  /** 
   * The state when the mic is in recording mode\state and listening from user.
   */
  Recording = 'Recording',

  /** 
   * The state when the mic is in paused mode\state and not listening from user. 
   */
  Paused = 'Paused'
}

export interface AppMicWidgetProps extends React.ClassAttributes<AppMicWidget> {
  type: 'AppMicWidgetProps';

  /**
   * Whether the mic widget is enabled or not.
   */
  isEnabled: boolean;

  /**
   * The current state\mode of mic widget.
   */
  currentMicState: AppMicWidgetRecorderState;

  /**
   * Callback to parent component, for the click events, received by the mic widget.
   */
  onMicWidgetClicked?: () => void;
}
